import React from 'react';
import { Select } from 'antd';
import useCategory from '@/hooks/useCategory';

const { Option } = Select;

export default function SelectActivityLevel({ value, onChange, ..._props }) {
  const [loading, categories] = useCategory();

  return (
    <Select allowClear {..._props} loading={loading} onChange={onChange} value={value}>
      {categories.map((item) => {
        return (
          <Option key={item.categoryId} value={item.categoryId}>
            {item.categoryName}
          </Option>
        );
      })}
    </Select>
  );
}
